<div class="Flex--row Statistikmonitor">

    <div class="Flex--col Card hide-on-print" style="padding:20px;min-width:320px;max-width:320px">
        <h3>Raumeinheit:</h3>
        <select v-model="spatialUnit" class="Input">
            <option v-if="spatialUnit==null" :value="null">Bitte wählen</option>
            <option v-for="su in getSpatialUnits(['K'])" :value="su">{{su.properties.name}}</option>
        </select>

        <template v-if="spatialUnit != null">
            <p>
                <Superbutton v-if="spatialUnit != null" label="Drucken" icon="/img/print.svg" :set="true" @click="print()" />
            </p>
            <p style="margin-top:0px;font-size:0.9em">Empfohlen wird der Druck im Querformat.</p>
        </template>
    </div>

    <div class="Flex--col Card" style="padding:20px">

        <h1 class="hide-on-screen">STATISTIKMONITOR Rhein-Neckar</h1>


        <template v-if="spatialUnit == null">
            <h1>TOP-Indikatoren</h1>
            <p class="Statistikmonitor__Description">Übersichtsblatt für jede MRN-Raumeinheit mit ausgewählten TOP-Indikatoren (Relativwerte)</p>
            <p class="Statistikmonitor__Hint">Bitte wählen Sie eine Raumeinheit (Kreisebene).</p>
        </template>
        <template v-else>


            <h2>{{spatialUnit.properties.name}}</h2>

            <table class="Table">

                <tr>
                    <th colspan="2a">Ausgewählte strukturrelevante Indikatoren</th>

                    <th v-for="su in compareUnits" class="numeric">{{su.properties.name}}</th>
                </tr>


                <tr v-for="indi in getTopIndicators()">


                    <td>
                        <button class="Statistikmonitor__GlossaryButton hide-on-print" @click="openGlossary(getGlossaryLink(indi.code))" alt="Glossar zum Themenbereich öffnen" title="Glossar zum Themenbereich öffnen">
                            <img src="tivigi/img/question.svg" />
                        </button>
                    </td>



                    <td>
                        {{indi.name}}, {{getIndicatorDisplayDate(indi, getLatestYear(spatialUnit, indi.code))}}</td>

                    <td v-for="su in compareUnits" class="numeric">{{getValue(su, indi.code, getLatestYear(su, indi.code)) | formatNumber(indi.decimal_places)}}</td>

                </tr>

            </table>


        </template>

    </div>

</div>